/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreMewsViewerAliases {
  ACTION_INACTIVATE_SCORE_MEWS = 'action-inactivate-score-mews',
  ACTION_NEW_SCORE_MEWS = 'action-new-score-mews',
  ACTION_REFERENCE_SCORE_MEWS = 'action-reference-score-mews',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_CONSCIOUSNESS_LEVEL = 'field-consciousness-level',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_HEART_RATE = 'field-heart-rate',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PUNCTUATION = 'field-punctuation',
  FIELD_RESPIRATORY_RATE = 'field-respiratory-rate',
  FIELD_SYSTOLIC_PA = 'field-systolic-pa',
  FIELD_TEMPERATURE = 'field-temperature',
  FORM_SCORE_MEWS_VIEWER = 'form-score-mews-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_EVATUALION_DATE = 'input-evatualion-date',
  LAYOUT_SCORE_MEWS_VIEWER = 'layout-score-mews-viewer',
  TEXT_CONSCIOUSNESS_LEVEL = 'text-consciousness-level',
  TEXT_DESCRIPTION = 'text-description',
  TEXT_HEART_RATE = 'text-heart-rate',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_PUNCTUATION = 'text-punctuation',
  TEXT_RESPIRATORY_RATE = 'text-respiratory-rate',
  TEXT_SYSTOLIC_PA = 'text-systolic-pa',
  TEXT_TEMPERATURE = 'text-temperature',
}
export { ScoreMewsViewerAliases };
